var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.promotionSignup = {
    attach: function (context) {
      var $emailContainerNodes = $('.promotion-signup-container', context);

      if (!$emailContainerNodes.length) {
        return null;
      }

      $emailContainerNodes.each(function () {
        var $containerNode = $(this);

        /* Close Button */
        $containerNode
          .find('.close-button')
          .off('click')
          .on('click', function () {
            $containerNode.slideUp(600);

            return false;
          });
        /* Close Button */
        /* Show hide additional units */
        // grab class name from hidden unit
        var classShowHide = $containerNode.find("input[name='unit_class_reveal']").val()
          ? $containerNode.find('.' + $containerNode.find("input[name='unit_class_reveal']").val())
          : null;

        // hide the unit to begin with, if it exists
        if (classShowHide && classShowHide.length > 0) {
          $('.' + classShowHide).hide();
        }
        /* Submit Form */
        var $promotionFormNode = $containerNode.find('form'),
          $promotionSubmitNode = $containerNode.find("input[type='submit']"),
          $promotionProgressNode = $containerNode.find('div.progress'),
          $promotionSuccessNode = $containerNode.find('div.success'),
          $promotionErrorNode = $containerNode.find('ul.error_messages'),
          $promotionOverLimitNode = $containerNode.find('div.over_limit'),
          $promotionSubmissionOption = $containerNode.find("input[name='redirect_or_text']"),
          $promotionRedirectURL = $containerNode.find("input[name='redirect']"),
          $promotionSignupText = $containerNode.find('div.promotion_signup_text'),
          $promotionSignupFields = $containerNode.find('div.promotion_signup_fields'),
          $emailOptStatusNode = $('#address-info-newsletter', '.signin-block__checkboxes');

        $promotionFormNode
          .not('.email-form-processed')
          .addClass('email-form-processed')
          .off('submit')
          .on('submit', function (submitEvt) {
            submitEvt.preventDefault();
            $promotionSubmitNode.addClass('hidden');
            $promotionProgressNode.removeClass('hidden');

            // Get all the fields in code because 'serialize' encodes bad emails and doesn't decode plus symbols.
            var inputFields = [
              '_SUBMIT',
              'REQUEST_TYPE',
              'PROMOTION_ID',
              'ADDRESS_TYPE',
              'LAST_SOURCE',
              'FIRST_NAME',
              'LAST_NAME',
              'ADDRESS1',
              'ADDRESS2',
              'ADDRESS3',
              'POSTAL_CODE',
              'PHONE1',
              'PC_EMAIL_ADDRESS',
              'PC_EMAIL_PROMOTIONS',
              'TERMS'
            ];
            var selectFields = ['BIRTH_DAY', 'BIRTH_MONTH', 'BIRTH_YEAR'];
            // Create an object to hold all the parameters and their values.
            var paramObj = {};

            // Loop through each input field and get its value.
            $.each(inputFields, function (index, value) {
              var inputField = $('.js-promotion-signup input[name=' + value + ']');

              paramObj[value] = inputField.val();
              if (inputField.is(':checked')) {
                paramObj[value] = 1;
              }
            });

            // Loop through each select field and get its value.
            $.each(selectFields, function (index, value) {
              var selectField = $('.js-promotion-signup select[name=' + value + ']');

              paramObj[value] = selectField.val();
            });

            // send the data via a json rpc call
            generic.jsonrpc.fetch({
              method: 'rpc.form',
              params: [paramObj],
              onBoth: function (jsonRpcResponse) {
                // Add the error messages below the header
                var errorObjectsArray = jsonRpcResponse.getMessages();

                if (errorObjectsArray) {
                  generic.showErrors(errorObjectsArray, $promotionErrorNode, $promotionFormNode);

                  // Show error messages in this template
                  $promotionErrorNode.removeClass('hidden').show();
                  $promotionProgressNode.addClass('hidden');
                  // just in case
                  if (classShowHide && classShowHide.length > 0) {
                    $('.' + classShowHide).hide();
                  }
                  $promotionSubmitNode.removeClass('hidden');
                  // promotionInputNode.addClass('error');
                  $containerNode.removeClass('email_success');

                  // Check to see if the maximum limit is reached
                  $.each(errorObjectsArray, function (index, element) {
                    if (element.key === 'sweeps_over_limit') {
                      // Show over limit messages within this template
                      $promotionProgressNode.addClass('hidden');
                      $promotionOverLimitNode.removeClass('hidden');
                      $promotionErrorNode.addClass('hidden').hide();
                      $promotionFormNode.addClass('hidden');
                      $emailOptStatusNode.addClass('hidden');
                      $promotionSignupText.addClass('hidden');
                      $promotionSignupFields.addClass('hidden');
                      $containerNode.addClass('email_success');
                      $('html,body').animate(
                        {
                          scrollTop: $('.over_limit').offset().top - 130
                        },
                        1000
                      );
                      // check to see if we have a class name
                      if (classShowHide && classShowHide.length > 0) {
                        $('.' + classShowHide).css('visibility', 'hidden');
                        $('.' + classShowHide).show();
                        // This is required as hidden slider blocks compute on document ready with width 0
                        // so we need to refresh the block to display properly and we dont want the user watching all this
                        // so we hide it whilst it is all happening
                        $('.slick-slider').slick('setOption', 'refresh', true, true);
                        $('.' + classShowHide).css('visibility', 'visible');
                      }
                    }
                  });

                  $(document).trigger('promotion:failure', $containerNode.find("input[name='PROMOTION_ID']"));
                } else {
                  if ($promotionSubmissionOption.val() === 'redirect' && $promotionRedirectURL.val().length > 0) {
                    // Redirect the current page to another
                    var dest = $promotionRedirectURL.val();

                    if (/^\/.+$/.test(dest)) {
                      dest = dest.replace(/^(\s|\/)+/, '');
                    }
                    if (/^(?!http|\/).+$/.test(dest)) {
                      dest = Drupal.settings.basePath + dest;
                    }
                    window.location.href = dest;

                    return false;
                  } else {
                    // Show success messages within this template
                    $promotionProgressNode.addClass('hidden');
                    $promotionSuccessNode.removeClass('hidden');
                    $promotionErrorNode.addClass('hidden').hide();
                    $promotionFormNode.addClass('hidden');
                    $emailOptStatusNode.addClass('hidden');
                    $promotionSignupText.addClass('hidden');
                    $promotionSignupFields.addClass('hidden');
                    $containerNode.addClass('email_success');
                    $('html,body').animate(
                      {
                        scrollTop: $('.success').offset().top - 130
                      },
                      1000
                    );
                    // check to see if we have a class name
                    if (classShowHide && classShowHide.length > 0) {
                      $('.' + classShowHide).css('visibility', 'hidden');
                      $('.' + classShowHide).show();
                      // This is required as hidden slider blocks compute on document ready with width 0
                      // so we need to refresh the block to display properly and we dont want the user watching all this
                      // so we hide it whilst it is all happening
                      $('.slick-slider').slick('setOption', 'refresh', true, true);
                      $('.' + classShowHide).css('visibility', 'visible');
                    }
                    $(document).trigger('promotion:success', $containerNode.find("input[name='PROMOTION_ID']"));
                  }
                }
              }
            });
          });
        /* Submit Form */
      });

      var $submitButton = $('#promotion_promotion_submit');
      var $enableSubmit = $('.enable_submit');

      if ($enableSubmit[0]) {
        $submitButton.prop('disabled', true);
        $submitButton.addClass('disabled');
        $enableSubmit.on('click', function () {
          if ($submitButton.prop('disabled')) {
            $submitButton.prop('disabled', false);
            $submitButton.removeClass('disabled');
          } else {
            $submitButton.prop('disabled', true);
            $submitButton.addClass('disabled');
          }
        });
      }

      this.populateSelect('form--profile_preferences--field--BIRTH_DAY', 1, 31);
      this.populateSelect('form--profile_preferences--field--BIRTH_MONTH', 1, 12);
      this.populateSelect('form--profile_preferences--field--BIRTH_YEAR', 1901, 2010);
      $('#terms_trigger').on('click', function () {
        $('#terms_details').toggle();
        $('#terms_arrow_1').toggle();
        $('#terms_arrow_2').toggle();
      });
      $('#terms_anchor_trigger').on('click', function () {
        $('#terms_details').toggle();
        $('#terms_arrow_1').toggle();
        $('#terms_arrow_2').toggle();
      });
    },
    populateSelect: function (target, min, max) {
      if (!target) {
        return false;
      } else {
        min = min || 0;
        max = max || min + 100;

        var select = document.getElementById(target);

        for (var i = min; i <= max; i++) {
          var opt = document.createElement('option');

          opt.value = i;
          opt.innerHTML = i;
          select.appendChild(opt);
        }
      }
    }
  };

  Drupal.behaviors.selectBox = {
    toggleOptions: function ($newSelect) {
      if (!$newSelect.hasClass('js-select-box-disabled')) {
        $newSelect.children('.js-select-box-options').toggleClass('open');
        $newSelect.children('.js-select-box-label').toggleClass('open');
      }
    },
    setLabel: function ($oldSelect) {
      var selectedText = $oldSelect.children('option:selected').text() || $oldSelect.children('option').first().text();
      var $newSelect = $oldSelect.data('new-select-box-reference');

      if (!!$newSelect) {
        $newSelect.children('.js-select-box-label').text(selectedText);
      }
    }
  };
})(jQuery);
